import { useSelector } from "react-redux";
import { useAuth } from "./auth/AuthContext";
export function LeftSideMenu(props) {
    //console.log(props);
    const leftMenuReducer = useSelector(state => state.leftMenuReducer);
    var hidden = leftMenuReducer.showMenu ? '' : 'hidden';
    const { getUserInfo } = useAuth();
    const user = getUserInfo();

    return (
        <aside id="sidebar" className={`sidebar page-height ${hidden}` }>
            <ul className="sidebar-nav" id="sidebar-nav">
                <li className="nav-heading">Practice</li>
                <li className="nav-item">
                    <a className="nav-link collapsed" href="/Home/Chatbot">
                        <i className="bi bi-question-circle"></i>
                        <span>OpenAI - Ask Query</span>
                    </a>
                </li>
                <li className="nav-item">
                    <a className="nav-link collapsed" href="/Home/Imagebot">
                        <i className="bi bi-file-earmark-image"></i>
                        <span>OpenAI - Draw Image</span>
                    </a>
                </li>
                {user && (
                    <>
                        <li className="nav-item">
                            <a className="nav-link collapsed" href="/Home/Translator">
                                <i className="bi bi-translate"></i>
                                <span>Translator</span>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link collapsed" href="/Home/TreeGrid">
                                <i className="bi bi-tree-fill"></i>
                                <span>Folder Browser</span>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link collapsed" href="/Home/MediaViewer">
                                <i className="bi bi-film"></i>
                                <span>Media Viewer</span>
                            </a>
                        </li>
                    </>
                )}
                <li className="nav-item">
                    <a className="nav-link collapsed" href="/Home/OCR">
                        <i className="bi bi-optical-audio-fill"></i>
                        <span>Optical Character Recognition</span>
                    </a>
                </li>
                <li className="nav-item">
                    <a className="nav-link collapsed" href="/Home/InfiniteScroll">
                        <i className="bi bi-arrow-down-up"></i>
                        <span>Infinite Scroll</span>
                    </a>
                </li>
        </ul>
      </aside>
  );
}
